import { useCallback } from "react";

import type { HotelPolicyUpdateMutationVariables } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { HOTEL_APPLICATION_DATA_QUERY } from "@/components/features/_shared/repository/hotel-application-data/query/schema";
import { START_GUIDE_QUERY } from "@/components/features/_shared/repository/start-guide/query/schema";

import { HOTEL_POLICY_UPDATE_MUTATION } from "./mutation";

export const useHotelPolicyMutation = (hotelID: string) => {
	const { mutationFunc: hotelPolicyMutationFunc } = useCustomMutation(HOTEL_POLICY_UPDATE_MUTATION);

	const onUpdateHotelPolicy = useCallback(
		async (variables: HotelPolicyUpdateMutationVariables) => {
			return hotelPolicyMutationFunc({
				variables,
				refetchQueries: [
					{
						query: START_GUIDE_QUERY,
						variables: {
							hotelID,
						},
					},
					{
						query: HOTEL_APPLICATION_DATA_QUERY,
						variables: {
							hotelID: hotelID,
						},
					},
				],
			});
		},
		[hotelID, hotelPolicyMutationFunc],
	);

	return {
		onUpdateHotelPolicy,
	};
};
